import React, { useEffect, useRef, useState } from 'react';
import { FaPlayCircle } from 'react-icons/fa';
import { IDetailPageThumbnailBarProps } from 'src/pages/DetailPage/components/DetailPageThumbnailBar.i';
import { DetailPageThumbnail, DetailPageThumbnailBarLotExtensionContainer, DetailPageThumbnailsContainer, DetailPageThumbnailsSection } from 'src/pages/DetailPage/components/DetailPageThumbnailBar.style';
import styled from 'styled-components';
import NRAFFFLogo from 'images/NRAFFF LOGO-2.png';

const widthRange = [62, 90];
const marginRange = [9, 15];
const countRange = [3, 8];

const NRAFFLogo = styled.img`
  position: absolute;
  left: 2px;
  bottom: 2px;
  width: 62%;
`;

export const DetailPageThumbnailBar = ({
  photos, videos, lotExtensions, auctionId,
  activePhotoIndex, setActivePhotoIndex,
  activeSubPhotoIndex, setActiveSubPhotoIndex,
  activeVideoIndex, setActiveVideoIndex,
  NRAID,
}: IDetailPageThumbnailBarProps) => {
  const sectionRef = useRef<HTMLDivElement>();
  const [width, setWidth] = useState(widthRange[0]);
  const [margin, setMargin] = useState(marginRange[0]);

  const getThumbnailMarginCount = () => {
    let finalWidth = widthRange[1];
    let finalMargin = marginRange[1];
    let finalCount = countRange[1];
    let finalTotalWidth = 0;

    const screenWidth = sectionRef.current && sectionRef.current.clientWidth;

    for(let w = widthRange[1]; w >= widthRange[0]; w -= 1) {
      for(let m = marginRange[1]; m >= marginRange[0]; m -= 1) {
        for(let count = countRange[1]; count >= countRange[0]; count--) {
          const currentScreenWidth = w * count + (m * (count - 1));
          if(currentScreenWidth <= screenWidth && currentScreenWidth > finalTotalWidth) {
            finalWidth = w;
            finalMargin = m;
            finalCount = count;
            finalTotalWidth = currentScreenWidth;
          }
          if(currentScreenWidth === screenWidth) {
            setWidth(finalWidth);
            setMargin(finalMargin - 0.25);
            return;
          }
        }
      }
    }
    setWidth(finalWidth);
    setMargin(finalMargin);
  };
  const onResize = () => {
    getThumbnailMarginCount();
  };
  useEffect(() => {
    if(!sectionRef.current) return;
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [sectionRef.current]);
  useEffect(() => {
    getThumbnailMarginCount();
  }, [sectionRef?.current?.clientWidth]);

  return (
    <DetailPageThumbnailsSection ref={sectionRef}>
      <DetailPageThumbnailsContainer margin={margin}>
        {photos?.map((photo, photoIndex) => {
          return <React.Fragment key={photoIndex}>
            {photoIndex === 1
              && videos?.map((video, videoIndex) => (
                <DetailPageThumbnail
                  width={width}
                  margin={margin}
                  key={video}
                  active={activeVideoIndex === videoIndex}
                  onPress={() => {
                    setActivePhotoIndex(0);
                    setActiveSubPhotoIndex(0);
                    setActiveVideoIndex(videoIndex);
                  }}
                >
                  <img
                    src={`https://img.youtube.com/vi/${video.replace(/.+\/embed\/(.+)/gm, '$1').replace(/\?.+/gm, '')}/1.jpg`}
                  />
                  <FaPlayCircle/>
                </DetailPageThumbnail>
              ))
            }
            {(photo as string[]).map && (
              <DetailPageThumbnailBarLotExtensionContainer>
                <strong>{lotExtensions[photoIndex - 1] || 'A'}</strong><br/>
                <div>
                  {(photo as string[]).map((singlePhoto, subPhotoIndex) => (
                    <DetailPageThumbnail
                      width={width}
                      margin={margin}
                      key={singlePhoto as string}
                      active={activePhotoIndex === photoIndex && activeSubPhotoIndex === subPhotoIndex + 1 && activeVideoIndex === -1}
                      onPress={() => {
                        setActivePhotoIndex(photoIndex);
                        setActiveSubPhotoIndex(subPhotoIndex + 1);
                        setActiveVideoIndex(-1);
                      }}
                    >
                      <img
                        src={
                          singlePhoto === 'notfound'
                            ? `${window.CDN_PATH}notfound_thumb.png`
                            : `${window.CDN_PATH}${auctionId}/thumbs/${singlePhoto}`
                        }
                      />
                      {NRAID && <NRAFFLogo
                        src={NRAFFFLogo}
                      />}
                    </DetailPageThumbnail>
                  ))}
                </div>
              </DetailPageThumbnailBarLotExtensionContainer>
            ) || (
              <DetailPageThumbnail
                width={width}
                margin={margin}
                active={activePhotoIndex === photoIndex && activeSubPhotoIndex === 0 && activeVideoIndex === -1}
                onPress={() => {
                  setActivePhotoIndex(photoIndex);
                  setActiveSubPhotoIndex(0);
                  setActiveVideoIndex(-1);
                }}
              >
                <img
                  src={
                    photo === 'notfound'
                      ? `${window.CDN_PATH}notfound_thumb.png`
                      : `${window.CDN_PATH}${auctionId}/thumbs/${photo}`
                  }
                />
                {NRAID && <NRAFFLogo
                  src={NRAFFFLogo}
                />}
              </DetailPageThumbnail>
            )}
          </React.Fragment>;
        })}
      </DetailPageThumbnailsContainer>
    </DetailPageThumbnailsSection>
  );
};
